import React from 'react';
import CrmOverviewDashboard from 'components/app/crm/dashboard/overview/CrmOverviewDashboard';

const CrmOverviewDashboardPage = () => <CrmOverviewDashboard />;

export default CrmOverviewDashboardPage;
